import styled, { css } from "styled-components";

export const ModalRoot = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 11;
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  opacity: 1;
`;

export const ModalContainer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  z-index: 12;
`;

export const ModalWrap = styled.div`
  background-color: ${({ theme }) => theme.colours.mineShaftGray};
  border-radius: 10px;
  padding: 10px 0 5px 0;
  text-align: center;
  font: ${({ theme }) => theme.typography.regularFontHd};
  ${(p) =>
    p.size === "sm" &&
    css`
      width: 395px;
    `};
`;

export const ModalHeader = styled.div`
  h2 {
    color: ${({ theme }) => theme.colours.white};
    font-weight: 600;
  }
`;

export const ModalBody = styled.div`
  padding: 5px 30px 10px 30px;
  color: ${({ theme }) => theme.colours.white};
  font-size: ${({ theme }) => theme.typography.mediumSwimlaneFontSize};
  word-break: break-word;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 15px;
`;

export const PrimaryButton = styled.button`
  width: 335px;
  height: 46px;
  margin-bottom: 0;
  font: ${({ theme }) => theme.typography.regularFont};
  font-size: ${({ theme }) => theme.typography.mediumFontSize};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.colours.buttonBackground};
  color: #fff;
  &:hover {
    background: ${({ theme }) => theme.colours.subscribeLink};
  }
  .user-is-tabbing &:focus {
    outline: auto;
  }
`;
